import { Document, Page, Text, View } from "@react-pdf/renderer";
import * as React from "react";
import ArchiveOrderPdfDetails from "./ArchiveOrderPdfDetails";
import { OrderPdfProps } from "../types";
import OrderDetailsPdf from "../OrderDetailsPdf";
import OrderCostSummaryPdf from "../OrderCostSummaryPdf";
import { ResearchAndSmallBusinessFootnote } from "../../Footnotes";

/**
 * Shows a pdf summary of a single order.
 */
const ArchiveOrderPDF = (props: OrderPdfProps) => {
  const { user, order, currentCostingVersion, styles } = props;

  return (
    <Document>
      <Page style={styles.pageStyles}>
        <OrderDetailsPdf {...props} />

        <View>
          <ArchiveOrderPdfDetails />
        </View>

        <OrderCostSummaryPdf
          user={user}
          order={order}
          currentCostingVersion={currentCostingVersion}
          styles={styles}
          annualTotalCostFootnoteRef="*"
        />

        <View style={styles.disclaimers}>
          <View style={[styles.disclaimer, styles.flexRow]}>
            <View>
              <Text>
                *
              </Text>
            </View>

            <View style={styles.disclaimerContent}>
              <Text style={styles.listItem}>
                <ResearchAndSmallBusinessFootnote pdf />
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default ArchiveOrderPDF;
